var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEthers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2235_133)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2235_133",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 62,
    height: 62
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62 0H0V62H62V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2235_133)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.5087 44.9389C29.8287 49.2015 6.50321 54.3213 6.15816 33.3066C6.15816 33.3066 6.87127 25.1639 16.8777 24.6512C16.8777 24.6512 17.2152 17.4192 24.8599 16.6003C28.9699 16.1565 33.6395 20.3809 34.1456 24.8272C34.1456 24.8272 44.2594 22.9599 44.6964 32.8014C44.8498 36.23 44.0753 42.0613 34.3219 41.8089C34.3219 41.8089 28.6785 41.0436 27.9116 32.3346C26.3244 49.1939 50.7464 48.2143 51.0991 32.9009C51.2524 26.2812 47.0044 19.4703 37.4351 20.7483C32.1902 7.57769 18.2272 8.33533 13.0285 20.5492C5.59841 20.5492 -0.0834188 26.2583 0.000926914 33.7122C0.284636 57.7038 33.7391 50.4719 62.5087 44.9389Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2235_133"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 62,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthers);
export default __webpack_public_path__ + "static/media/ethers.4652e00df1a444dc8271ecf7b86e17ff.svg";
export { ForwardRef as ReactComponent };